// ============================================================
// Datei: src/App.js
// PURPOSE:
// Haupt-Routing + globaler Background-Reveal + Footer unten
// ============================================================

import React, { useEffect } from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	useLocation
} from "react-router-dom";

// ============================================================
// Layout
// ============================================================

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// ============================================================
// Pages (Top-Level)
// ============================================================

import Home from "./pages/home/Home";
import Login from "./pages/Login";
import Register from "./pages/register/Register";
import Admin from "./pages/admin/Admin";

// ============================================================
// Deployment
// ============================================================

import Deployment from "./pages/deployment/Deployment";

// ============================================================
// Ressorts
// ============================================================

import Bar from "./pages/ressorts/bar/Bar";
import Chai from "./pages/ressorts/chai/Chai";
import Hang from "./pages/ressorts/hang/Hang";
import Infostand from "./pages/ressorts/infostand/Infostand";
import Kasse from "./pages/ressorts/kasse/Kasse";
import Infrastruktur from "./pages/ressorts/infrastruktur/Infrastruktur";
import Caipibar from "./pages/ressorts/caipibar/Caipibar";
import Deko from "./pages/ressorts/deko/Deko";
import Kaffimobil from "./pages/ressorts/kaffimobil/Kaffimobil";
import Sarasani from "./pages/ressorts/sarasani/Sarasani";
import Food from "./pages/ressorts/food/Food";
import Shuttle from "./pages/ressorts/shuttle/Shuttle";
import Awareness from "./pages/ressorts/awareness/Awareness";
import UmweltAmbiente from "./pages/ressorts/umweltAmbiente/UmweltAmbiente";
import Kindernami from "./pages/ressorts/kindernami/Kindernami";
import Parkplatz from "./pages/ressorts/parkplatz/Parkplatz";
import Programm from "./pages/ressorts/programm/Programm";
import Kommunikation from "./pages/ressorts/kommunikation/Kommunikation";
import KulturGeschichte from "./pages/ressorts/kulturGeschichte/KulturGeschichte";
import Administration from "./pages/ressorts/administration/Administration";

// ============================================================
// Passwort Reset
// ============================================================

import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

// ============================================================
// Rechtliches
// ============================================================

import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";

// ============================================================
// Styles / Background
// ============================================================

import "./styles/backgroundReveal.css";
import "./styles/global.css";
import { preloadBackgrounds } from "./utils/preloadBackgrounds";

// ============================================================
// Globaler Background Controller
// ============================================================

const BackgroundHandler = () => {
	const location = useLocation();

	useEffect(() => {
		if (typeof preloadBackgrounds === "function") {
			preloadBackgrounds();
		}

		const elements = document.querySelectorAll("[data-bg]");

		elements.forEach((el) => {
			const url = el.dataset.bg;
			if (!url) return;

			el.classList.remove("bg-loaded");

			const img = new Image();
			img.src = url;

			img.onload = () => {
				el.style.setProperty("--bg-url", `url(${url})`);
				setTimeout(() => el.classList.add("bg-loaded"), 40);
			};
		});
	}, [location.pathname]);

	return null;
};

// ============================================================
// App
// ============================================================

const App = () => {
	return (
		<Router>
			<div className="app-wrapper">
				<Navbar />
				<BackgroundHandler />

				<main className="page-content">
					<Routes>
						{/* Home */}
						<Route path="/" element={<Home />} />

						{/* Auth */}
						<Route path="/login" element={<Login />} />
						<Route path="/register" element={<Register />} />

						{/* Passwort Reset */}
						<Route path="/forgot-password" element={<ForgotPassword />} />
						<Route path="/reset-password" element={<ResetPassword />} />

						{/* Admin Page */}
						<Route path="/admin" element={<Admin />} />

						{/* Deployment */}
						<Route path="/deployment" element={<Deployment />} />

						{/* Ressorts */}
						<Route path="/ressort/bar" element={<Bar />} />
						<Route path="/ressort/chai" element={<Chai />} />
						<Route path="/ressort/hang" element={<Hang />} />
						<Route path="/ressort/infostand" element={<Infostand />} />
						<Route path="/ressort/kasse" element={<Kasse />} />
						<Route path="/ressort/infrastruktur" element={<Infrastruktur />} />
						<Route path="/ressort/caipibar" element={<Caipibar />} />
						<Route path="/ressort/deko" element={<Deko />} />
						<Route path="/ressort/kaffimobil" element={<Kaffimobil />} />
						<Route path="/ressort/sarasani" element={<Sarasani />} />
						<Route path="/ressort/food" element={<Food />} />
						<Route path="/ressort/shuttle" element={<Shuttle />} />
						<Route path="/ressort/awareness" element={<Awareness />} />
						<Route path="/ressort/umweltAmbiente" element={<UmweltAmbiente />} />
						<Route path="/ressort/kindernami" element={<Kindernami />} />
						<Route path="/ressort/parkplatz" element={<Parkplatz />} />
						<Route path="/ressort/programm" element={<Programm />} />
						<Route path="/ressort/kommunikation" element={<Kommunikation />} />
						<Route path="/ressort/kulturGeschichte" element={<KulturGeschichte />} />
						<Route path="/ressort/administration" element={<Administration />} />

						{/* Rechtliches */}
						<Route path="/impressum" element={<Impressum />} />
						<Route path="/datenschutz" element={<Datenschutz />} />
					</Routes>
				</main>

				<Footer />
			</div>
		</Router>
	);
};

export default App;